// extracted by mini-css-extract-plugin
var _1 = "CalendarRailBlock-moduleCalendarRailBlock__wwqIy";
var _2 = "CalendarRailBlock-moduleheader__yYkL5";
export { _1 as "CalendarRailBlock", _2 as "header" }
